<template>
  <div id="authormanage">
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="FILE">文件</el-menu-item>
      <el-menu-item index="FILEMETA">文件类型</el-menu-item>
      <el-menu-item index="DS">数据源</el-menu-item>
      <el-menu-item index="DB">数据库</el-menu-item>
      <el-menu-item index="TABLE">数据库表</el-menu-item>
      <el-menu-item index="BUCKET">Bucket</el-menu-item>
      <el-menu-item index="DiRes">数据接口</el-menu-item>
    </el-menu>
    <div class="content">
      <div class="button-group">
        <div class="button-title">授权列表</div>
        <div class="filling"></div>
        <el-select
          v-show="typeShow"
          size="small"
          v-model="searchType"
          placeholder="授权类型"
          clearable
          @change="typeChange"
          style="margin-right: 10px;"
        >
          <el-option label="USER" value="USER"></el-option>
          <el-option label="GROUP" value="GROUP"></el-option>
        </el-select>

        <el-select
          size="small"
          clearable
          v-model="searchId"
          placeholder="授权对象"
          style="margin-right: 10px;"
        >
          <el-option
            v-for="(item, i) in targetOptions"
            :key="i"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>

        <el-button
          size="small"
          icon="el-icon-search"
          class="search-button"
          @click="search"
        ></el-button>
        <el-button type="primary" size="small" @click="dialog = true"
          >添 加</el-button
        >
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        height="calc(100% - 64px - var(--padding))"
      >
        <el-table-column prop="resPath" label="资源路径" min-width="200">
        </el-table-column>
        <el-table-column prop="targetType" label="授权对象类型" min-width="120">
        </el-table-column>
        <el-table-column prop="targetName" label="授权对象" min-width="120">
        </el-table-column>
        <el-table-column prop="accessType" label="权限类型" min-width="120">
        </el-table-column>
        <el-table-column prop="authTime" label="授权时间" min-width="180">
        </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="scope">
            <el-tooltip
              content="删除"
              :visible-arrow="false"
              placement="top"
              effect="light"
              :open-delay="1000"
              :enterable="false"
              :hide-after="2500"
              transition="el-fade-in"
              popperClass="tooltip-config"
            >
              <i
                class="el-icon-ga-shanchu delete-icon icon-button"
                @click="fileDelete(scope.row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <page-trun
        :disabled="loading"
        :page="page"
        :queryData="queryData"
        @pageTrun="pageTrun"
      />
    </div>
    <author-dialog
      v-if="dialog"
      :activeIndex="activeIndex"
      :dialog.sync="dialog"
      @refush="handleSelect"
    />
  </div>
</template>

<script>
import authorDialog from "./dialog.vue";
import { Delete } from "@/utils/index";
export default {
  name: "authormanage",
  data() {
    return {
      loading: false,
      dialog: false,
      typeShow: true,
      activeIndex: "FILE",
      page: {
        pageIndex: 1,
        hasMore: false
      },
      queryData: {},
      targetType: "",
      targetId: "",
      searchType: "",
      searchId: "",
      targetOptions: []
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    tableData() {
      return this.queryData[
        `${this.activeIndex}_${this.targetType}_${this.targetId}_${this.page.pageIndex}`
      ];
    }
  },
  methods: {
    typeChange(a) {
      this.targetId = "";
      this.targetOptions = [];
      if (a !== null) {
        this.remoteMethod();
      }
    },
    remoteMethod() {
      let url = "/gavial/v1/permission/search/group?keyWord=";
      if (this.searchType === "USER") {
        url = "/gavial/v1/permission/search/user?keyWord=";
      }
      this.$http.get(url).then(res => {
        this.targetOptions = res.data.data;
      });
    },
    handleSelect(key) {
      this.targetType = "";
      this.targetId = "";
      this.searchType = "";
      this.searchId = "";
      this.queryData = {};
      this.activeIndex = key || this.activeIndex;
      this.page = {
        pageIndex: 1,
        hasMore: false
      };

      if (key === "DiRes") {
        this.typeShow = false;
        this.searchType = "GROUP";
        this.typeChange("GROUP");
      } else {
        this.typeShow = false;
      }

      this.getData(key);
    },
    fileDelete(row) {
      Delete(
        "/gavial/v1/permission/res/auth/revoke",
        `${row.resPath} 路径的授权`,
        () => {
          this.queryData = {};
          this.page = {
            pageIndex: 1,
            hasMore: false
          };
          this.getData(this.activeIndex);
        },
        bool => {
          this.loading = bool;
        },
        "post",
        {
          resPath: row.resPath,
          resType: row.resType,
          targetType: row.targetType,
          targetIds: [row.targetId],
          accessType: row.accessType
        }
      );
    },
    getData(key) {
      this.loading = true;
      this.$http
        .get(
          `/gavial/v1/permission/res/auth/list?resType=${key ||
            this.activeIndex}&targetType=${this.targetType}&targetId=${
            this.targetId
          }&pageIndex=${this.page.pageIndex}`
        )
        .then(res => {
          this.$set(
            this.queryData,
            `${key || this.activeIndex}_${this.targetType}_${this.targetId}_${
              res.data.pageIndex
            }`,
            res.data.data
          );
          this.page.pageIndex = res.data.pageIndex;
          this.page.hasMore = res.data.hasMore;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.page = {
        pageIndex: 1,
        hasMore: false
      };
      this.queryData = {};
      this.targetType = this.searchType;
      this.targetId = this.searchId;
      this.getData();
    },
    pageTrun(i) {
      this.page.pageIndex = i;
      if (
        !this.queryData[
          `${this.activeIndex}_${this.targetType}_${this.targetId}_${i}`
        ]
      ) {
        this.getData();
      }
    }
  },
  components: {
    "author-dialog": authorDialog
  }
};
</script>

<style lang="scss">
#authormanage {
  height: 100%;
  .el-menu {
    position: relative;
    top: var(--paddingf);
    margin: 0 var(--paddingf);
    padding: 0 var(--paddingf);
    .el-menu-item {
      height: 55px;
      line-height: 55px;
    }
  }
  .content {
    height: calc(100% - 55px - var(--padding) * 2);
    background: #ffffff;
    padding: var(--padding);
  }
}
</style>
